import { ref } from 'vue'

const isProduction = process.env.NODE_ENV === 'production'
const ga4Enabled = ref(false)
const isBrowser = typeof window !== 'undefined'
if (isBrowser) {
  window.dataLayer = window.dataLayer || []
}

function loadGA () {
  try {
    if (![null, undefined].includes(gtag)) {
      ga4Enabled.value = true
    }
    console.log('Google Analytics loaded.')
  } catch (e) {
    ga4Enabled.value = false
    console.log('Google Analytics not found.')
  }
}

loadGA()

export function useGA () {
  const ga4Event = (action, { eventCategory, eventLabel }) => {
    if (!isProduction || !isBrowser || !ga4Enabled.value) {
      return
    }
    gtag('event', action, {
      event_category: eventCategory,
      event_label: eventLabel
    })
    console.log('Sent to gtag: ', 'event', action, {
      event_category: eventCategory,
      event_label: eventLabel
    })
  }
  return {
    event: ga4Event,
    widgetEvent (analytics, eventName) {
      if (!isProduction || !isBrowser) {
        return
      }
      if (
        analytics &&
        eventName &&
        analytics.events &&
        analytics.events[eventName]
      ) {
        if (
          analytics.useGA4 &&
          analytics.events[eventName].action &&
          ga4Enabled.value
        ) {
          ga4Event(analytics.events[eventName].action, {
            eventCategory: analytics.events[eventName].eventCategory
              ? analytics.events[eventName].eventLabel
              : 'Category not set',
            eventLabel: analytics.events[eventName].eventLabel
              ? analytics.events[eventName].eventLabel
              : 'Label not set'
          })
          console.log('Sent Ga4Event: ', analytics.events[eventName].action, {
            eventCategory: analytics.events[eventName].eventCategory
              ? analytics.events[eventName].eventLabel
              : 'Category not set',
            eventLabel: analytics.events[eventName].eventLabel
              ? analytics.events[eventName].eventLabel
              : 'Label not set'
          })
        } else if (
          !analytics.useGA4 &&
          analytics.events[eventName].messageBody
        ) {
          try {
            const parsedBody = JSON.parse(
              analytics.events[eventName].messageBody
            )
            window.dataLayer.push(parsedBody)
            console.log('Sent universal event', parsedBody)
          } catch (e) {
            console.log('Failed to parse message body')
          }
        }
      }
    }
  }
}
